module.exports = __webpack_public_path__ + "img/expert-review-icon.0cbe6309.svg";